import React from "react";

function JumbotronViewMode(props) {
    return (
        <div className="questionaire__builder__question__form pv-md">
            <div className="questionaire__builder__question__form__text infobox_view_mode">
                {props.questionData.question}
            </div>
        </div>
    );
}

export default JumbotronViewMode;